const Moi = () => {
  return (
    <div className='flex items-center justify-center pb-5'>
      <div className='tracking-normal text-xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl'>
        <h1 className='text-slate-50 pt-5 pb-2 flex items-center justify-center font-bold text-3xl sm:text-6xl sm:pb-5 md:text-7xl lg:text-8xl xl:text-9xl 2xl:text-9xl'>Mừng Anh Mới Tới</h1>
        <p className='text-slate-300 pt-5 leading-tight'>
          Mừng anh anh mới tới,<br />
          Tới thăm chúng tôi nơi này<br />
          Lòng tôi hân hoan vui say<br />
          Khi trông thấy anh cười thật tươi<br /><br />
          Ối ối giời giời ơi<br />
          Mặt anh giống như mặt trời<br />
          Lòng tôi thêm vui say<br />
          Khi trông thấy anh cười thật tươi.
        </p>
      </div>
    </div>
  )
}

export default Moi
